import { useState } from "react";
import { Link } from "react-router-dom";
import Header from "./Header";
import Stars from "./Stars";
import x from "./intro-x.svg";
import logo from "./linkedin.svg";
import figma from "./figma.svg";
import react from "./react-logo.svg";
import circuit from "./circuit.svg";
import mongo from "./mongo.svg";
import micro from "./microsoft.svg";
import google from "./google.svg";
// import me from "./me.png";
import email from "./email.svg";
import pen from "./pen.svg";
import loop from "./research.svg";
import meme from "./meme.png";
import xd from "./xd.png";
import ps from "./photoshop.png";
import ai from "./illustrator.png";
import piece1000 from "./Ingles.jpg";
import ae from "./after_effects.png";
import fig from "./fig-logo.png";
import jtr from "./jttr.png";
import framer from "./framer.png";
import wflow from "./webflow.png";
import miro from "./miro.png";
import hotj from "./hotj.png";
import jira from "./jira.png";
import googleA from "./google-analyt.png";
import claude from "./claude.png";
import reactIc from "./react-icon.png";
import mongoL from "./mongo.png";
import satellite from "./satellite.gif";
import barchart from "./barchart.gif";
import clipboard from "./clipboard.gif";
import bulb from "./lightbulb.gif";
import server from "./server.gif";
import code from "./code.svg";
import wrench from "./wrench.svg";
import meta from "./meta.svg";
import piece10 from "./offmeta.png";
import piece1 from "./screen.png";
// import piece2 from "./3.png";
import piece4 from "./5.png";
import piece5 from "./6.png";
// import piece6 from "./crypto.png";
// import piece7 from "./battles.png";
import piece8 from "./8.png";
// import piece9 from "./sp.png";
// import fantasy from "./fantasy.png";
import js from "./js.svg";

const Home = () => {
  const [tooltip, setTooltip] = useState({
    visible: false,
    x: 0,
    y: 0,
  });
  const [tooltipText, setTooltipText] = useState("View Case Study");
  // const [isHovered, setIsHovered] = useState(false);
  return (
    <div>
      <Header />
      <div className="intro" id="star-container" style={{ paddingTop: "50px" }}>
        <Stars />
        <div className="parent">
          <div className="logo-box">
            <a href="https://www.linkedin.com/in/jason-azevedojs/" target="_blank" rel="noopener noreferrer">
              <img src={logo} alt="Jason Azevedo LinkedIn" />
            </a>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "4px",
                border: "1px solid #22c55e7a",
                borderRadius: "90px",
                padding: "6px 14px",
                background: "#22c55e24",
              }}>
              <div class="pulsating-circle" style={{ marginTop: "10px" }}></div>
              <p style={{ margin: "0", color: "rgb(61 246 129)", fontFamily: "DM Mono, monospace", fontSize: "11px", fontWeight: "400" }}>
                Available for projects
              </p>
            </div>
          </div>
          <div className="category">
            <hr />
            <p style={{ fontFamily: "DM Mono, monospace", fontSize: "12px", fontWeight: "400" }}>Welcome</p>
            <hr style={{ transform: "rotate(180deg)" }} />
          </div>
          <h2 className="test">UX/UI Product Designer</h2>
          <h2 className="sub-title" style={{ fontFamily: "DM Mono, monospace", fontSize: "16px", fontWeight: "400" }}>
            <b style={{ fontFamily: "DM Mono, monospace", fontSize: "16px", fontWeight: "400" }}>Hi! I'm</b> Jason Azevedo
            <p
              style={{
                marginBottom: "0px",
                lineHeight: "24px",
                fontFamily: "DM Mono, monospace",
                fontSize: "12px",
                fontWeight: "400",
                background: "none",
              }}
              id="bio">
              5+ years creating user-centered digital products. I combine UX research, analytics, and strategy to create experiences that drive real
              business growth. Doing a job is good, but doing a job knowing how to take your business to the next level is even better
            </p>
          </h2>
          <div className="introduction">
            <img src={circuit} alt="Descrs" style={{ position: "absolute", top: "6px" }} />
            <div className="feature" style={{ marginLeft: "9px" }}>
              <div>
                <div className="feature-cover">
                  <img src={figma} alt="Descrs" />
                </div>
              </div>
              <p style={{ fontFamily: "DM Mono, monospace", fontSize: "12px", fontWeight: "400" }}>Figma</p>
            </div>
            <div className="feature" style={{ marginLeft: "74px" }}>
              <div>
                <div className="feature-cover">
                  <img src={react} alt="Descrs" />
                </div>
              </div>
              <p style={{ fontFamily: "DM Mono, monospace", fontSize: "12px", fontWeight: "400" }}>React</p>
            </div>
            <div className="feature" style={{ marginLeft: "74px" }}>
              <div>
                <div className="feature-cover">
                  <img src={mongo} alt="Descrs" style={{ height: "36px" }} />
                </div>
              </div>
              <p style={{ fontFamily: "DM Mono, monospace", fontSize: "12px", fontWeight: "400" }}>PostgresSQL</p>
            </div>
            <div className="feature" style={{ marginLeft: "74px" }}>
              <div>
                <div className="feature-cover">
                  <img src={js} alt="Descrs" />
                </div>
              </div>
              <p style={{ textAlign: "center", fontFamily: "DM Mono, monospace", fontSize: "12px", fontWeight: "400" }}>Javascript ES6</p>
            </div>
          </div>
          <div className="intro-empty-1">
            <img src={x} alt="Descrs" />
          </div>
          <div className="intro-empty-2"></div>
          <div className="intro-empty-3"></div>
          <div className="intro-empty-4"></div>
          <div className="intro-empty-6"></div>
          <div className="intro-empty-7">
            <img src={x} alt="Descrs" />
          </div>
          <div className="intro-empty-8"></div>
          <div className="intro-empty-9"></div>
          <div className="intro-empty-10"></div>
          <div className="intro-empty-11"></div>
          <div className="intro-empty-12"></div>
          <div className="intro-empty-13"></div>
          <div className="intro-empty-14"></div>
          <div className="intro-empty-15"></div>
          <div className="intro-empty-16"></div>
          <div className="intro-empty-17"></div>
          <div className="intro-empty-18"></div>
          <div className="intro-empty-19"></div>
          <div className="intro-empty-20"></div>
        </div>
      </div>
      <div className="seperator"></div>
      <div className="cert">
        <h2 className="cert-sub">Certifications</h2>
        <div style={{ display: "flex", flexDirection: " row", gap: "60px", marginTop: "20px", alignItems: "flex-end" }}>
          <span className="cert-feat">
            <img src={micro} alt="de" />
            <p style={{ fontFamily: "DM Mono, monospace", fontSize: "12px", fontWeight: "400" }}>Microsoft UX Design Professional Certificate</p>
          </span>
          <span className="cert-feat">
            <img src={google} alt="de" />
            <p style={{ fontFamily: "DM Mono, monospace", fontSize: "12px", fontWeight: "400" }}>Google UX Design Professional Certificate</p>
          </span>
          <span className="cert-feat">
            <img src={meta} alt="de" />
            <p style={{ fontFamily: "DM Mono, monospace", fontSize: "12px", fontWeight: "400" }}>Meta Principles of UX/UI Design</p>
          </span>
        </div>
      </div>
      <div className="seperator"></div>
      {/* <div className="personal" style={{ display: "flex", gap: "40px" }}>
        <div className="card">
          <img src={me} alt="de" />
          <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
            <div class="pulsating-circle" style={{ marginTop: "20px" }}></div>
            <p style={{ fontSize: "12px", marginTop: "20px" }} id="pp">
              Available for work
            </p>
          </div>
          <h2 style={{ fontWeight: "500", fontSize: "36px", margin: "10px 0" }}>Jason Azevedo</h2>
          <p style={{ textAlign: "center", color: "#c8d4eac7", fontSize: "12px", marginBottom: "30px" }}>
            UI/UX Interaction Designer Based in Georgia.
          </p>
          <div style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "20px", marginBottom: "2rem" }}>
            <a href="https://www.linkedin.com/in/jason-azevedojs/" target="_blank" rel="noopener noreferrer">
              <img src={logo} alt="Jason Azevedo LinkedIn" style={{ width: "32px", height: "auto" }} />
            </a>
            <a href="mailto:jazeveedo17@gmail.com" target="_blank" rel="noopener noreferrer">
              <img src={email} alt="Jason Azevedo Email" style={{ width: "32px", height: "auto", borderRadius: "0" }} />
            </a>
          </div>
        </div>
        <div className="info">
          <div className="seperator"></div>
          <div style={{ display: "flex", gap: "20px", margin: "20px 0" }} className="d">
            <p style={{ background: "rgba(255, 255, 255, 0.06)", padding: "12px", width: "fit-content", borderRadius: "10px" }}>Product Design</p>
            <p style={{ background: "rgba(255, 255, 255, 0.06)", padding: "12px", width: "fit-content", borderRadius: "10px" }}>UX Design</p>
            <p style={{ background: "rgba(255, 255, 255, 0.06)", padding: "12px", width: "fit-content", borderRadius: "10px" }}>UI Design</p>
            <p style={{ background: "rgba(255, 255, 255, 0.06)", padding: "12px", width: "fit-content", borderRadius: "10px" }}>Interaction Design</p>
            <p style={{ background: "rgba(255, 255, 255, 0.06)", padding: "12px", width: "fit-content", borderRadius: "10px" }}>Branding</p>
            <p style={{ background: "rgba(255, 255, 255, 0.06)", padding: "12px", width: "fit-content", borderRadius: "10px" }}>UX Research</p>
          </div>
          <div className="seperator"></div>
          <div style={{ display: "flex", gap: "20px", flexDirection: "column", marginTop: "30px" }}>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                background: "rgba(255, 255, 255, 0.06)",
                padding: "2px 15px",
                borderRadius: "10px",
              }}>
              <p style={{ width: "200px" }}>Founder & CEO</p>
              <p style={{ width: "200px" }}>OffMeta Fantasy</p>
              <p>2024-2026</p>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                background: "rgba(255, 255, 255, 0.06)",
                padding: "2px 15px",
                borderRadius: "10px",
              }}>
              <p style={{ width: "200px" }}>Lead UX/UI Designer</p>
              <p style={{ width: "200px" }}>LeadrPro</p>
              <p>2024</p>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                background: "rgba(255, 255, 255, 0.06)",
                padding: "2px 15px",
                borderRadius: "10px",
              }}>
              <p style={{ width: "200px" }}>Freelance</p>
              <p style={{ width: "200px" }}>LoL Pickems</p>
              <p>2024</p>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                background: "rgba(255, 255, 255, 0.06)",
                padding: "2px 15px",
                borderRadius: "10px",
              }}>
              <p style={{ width: "200px" }}>UX/UI Designer</p>
              <p style={{ width: "200px" }}>Thistle Communications</p>
              <p>2023</p>
            </div>
          </div>
        </div>
      </div> */}
      <div className="middle" style={{ margin: "auto" }} id="section-skills">
        <div className="cert" style={{ margin: "160px 0 20px 0" }}>
          <h2 className="cert-sub">Skills & Expertise</h2>
          <div
            style={{
              display: "flex",
              flexDirection: " row",
              width: "100%",
              maxWidth: "1200px",
              marginTop: "20px",
              alignItems: "flex-end",
              padding: "0 10px",
              gap: "20px",
            }}>
            <div className="card" style={{ gap: "20px" }}>
              <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                <img
                  src={pen}
                  alt="Pen Design"
                  style={{
                    height: "36px",
                    border: "1px solid rgba(255, 255, 255, 0.2)",
                    padding: "8px",
                  }}
                />
                <h2 style={{ fontFamily: "DM Mono, monospace", fontSize: "20px", fontWeight: "500" }}>Design</h2>
              </div>
              <ul style={{ display: "flex", gap: "20px", flexDirection: "column", paddingLeft: "12px", width: "100%" }}>
                <li>Human-Centric Design</li>
                <li>Interaction Design</li>
                <li>Visual Design</li>
                <li>Prototyping</li>
                <li>Information Architecture</li>
                <li>Design Systems</li>
                <li>Accessibility (WCAG 2.2)</li>
              </ul>
            </div>
            <div className="card" style={{ gap: "20px" }}>
              <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                <img
                  src={loop}
                  alt="Pen Design"
                  style={{
                    height: "36px",
                    background: "radial-gradient(#05060f00 56%, rgba(216, 236, 248, 0.06));",
                    border: "1px solid rgba(255, 255, 255, 0.2)",
                    padding: "8px",
                  }}
                />
                <h2 style={{ fontFamily: "DM Mono, monospace", fontSize: "20px", fontWeight: "500" }}>Research</h2>
              </div>
              <ul style={{ display: "flex", gap: "20px", flexDirection: "column", paddingLeft: "12px", width: "100%" }}>
                <li>Journey Mapping</li>
                <li>Card Sorting</li>
                <li>In-Depth Interviews</li>
                <li>Ethnographic Research</li>
                <li>Competitive Analysis</li>
                <li>Heuristic Evaluation</li>
                <li>A/B Testing</li>
              </ul>
            </div>
            <div className="card" style={{ gap: "20px" }}>
              <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                <img
                  src={code}
                  alt="Pen Design"
                  style={{
                    height: "36px",
                    background: "radial-gradient(#05060f00 56%, rgba(216, 236, 248, 0.06));",
                    border: "1px solid rgba(255, 255, 255, 0.2)",
                    padding: "8px",
                  }}
                />
                <h2 style={{ fontFamily: "DM Mono, monospace", fontSize: "20px", fontWeight: "500" }}>Technical</h2>
              </div>
              <ul style={{ display: "flex", gap: "20px", flexDirection: "column", paddingLeft: "12px", width: "100%" }}>
                <li>HTML / CSS / React</li>
                <li>JavaScript</li>
                <li>SQL</li>
                <li>Postgres</li>
                <li>Git / GitHub</li>
                <li>Data Visualization</li>
                <li>Mobile Responsiveness</li>
              </ul>
            </div>
          </div>
        </div>
        <div
          className="card"
          style={{
            maxWidth: "1200px",
            margin: "auto",
            gap: "10px",
            marginBottom: "180px",
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
          }}>
          <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
            <img
              src={wrench}
              alt="Pen Design"
              style={{
                height: "36px",
                background: "radial-gradient(#05060f00 56%, rgba(216, 236, 248, 0.06));",
                border: "1px solid rgba(255, 255, 255, 0.2)",
                padding: "8px",
              }}
            />
            <h2 style={{ fontFamily: "DM Mono, monospace", fontSize: "20px", fontWeight: "500" }}>ToolBox</h2>
          </div>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-evenly", width: "100%", flexWrap: "wrap", gap: "6px" }}>
            <img src={fig} alt="fig" style={{ width: "40px", height: "40px", objectFit: "contain", borderRadius: "0" }} />
            <img src={xd} alt="XD" style={{ width: "40px", height: "40px", objectFit: "contain", borderRadius: "0" }} />
            <img src={ae} alt="ae" style={{ width: "40px", height: "40px", objectFit: "contain", borderRadius: "0" }} />
            <img src={ai} alt="ai" style={{ width: "40px", height: "40px", objectFit: "contain", borderRadius: "0" }} />
            <img src={ps} alt="ps" style={{ width: "40px", height: "40px", objectFit: "contain", borderRadius: "0" }} />
            <img src={framer} alt="ps" style={{ width: "40px", height: "40px", objectFit: "contain", borderRadius: "0" }} />
            <img src={jtr} alt="ps" style={{ width: "40px", height: "40px", objectFit: "contain", borderRadius: "0" }} />
            <img src={wflow} alt="ps" style={{ width: "40px", height: "40px", objectFit: "contain", borderRadius: "0" }} />
            <img src={miro} alt="ps" style={{ width: "40px", height: "40px", objectFit: "contain", borderRadius: "0" }} />
            <img src={hotj} alt="ps" style={{ width: "40px", height: "40px", objectFit: "contain", borderRadius: "0" }} />
            <img src={jira} alt="ps" style={{ width: "40px", height: "40px", objectFit: "contain", borderRadius: "0" }} />
            <img src={googleA} alt="ps" style={{ width: "40px", height: "40px", objectFit: "contain", borderRadius: "0" }} />
            <img src={mongoL} alt="ps" style={{ width: "40px", height: "40px", objectFit: "contain", borderRadius: "0" }} />
            <img src={reactIc} alt="ps" style={{ width: "40px", height: "40px", objectFit: "contain", borderRadius: "0" }} />
            <img src={claude} alt="ps" style={{ width: "40px", height: "40px", objectFit: "contain", borderRadius: "0" }} />
          </div>
        </div>
      </div>
      <div className="seperator"></div>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "flex-start",
          maxWidth: "1200px",
          margin: "160px auto 160px auto",
          gap: "40px",
          padding: "0 10px",
        }}
        className="middle"
        id="section-about">
        <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", width: "30%" }}>
          <img
            src={meme}
            alt="ps"
            style={{ width: "100%", objectFit: "contain", borderRadius: "10px", border: "1px solid rgba(255, 255, 255, 0.2)" }}
          />
          <div
            className="logo-box"
            style={{ gap: "6px", paddingTop: "10px", paddingBottom: "0", width: "100%", flexDirection: "column", alignItems: "flex-start" }}>
            <div style={{ display: "flex", gap: "6px", alignItems: "center", border: "none" }}>
              <a href="https://www.linkedin.com/in/jason-azevedojs/" target="_blank" rel="noopener noreferrer" style={{ textDecoration: "none" }}>
                <p
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "4px",
                    border: "1px solid #98c0ef",
                    borderRadius: "90px",
                    padding: "6px 14px",
                    background: "#98c0ef26",
                    fontFamily: "DM Mono, monospace",
                    fontSize: "12px",
                    fontWeight: "500",
                    color: "#d8ecf8",
                  }}>
                  <img src={logo} alt="Jason Azevedo LinkedIn" style={{ height: "16px" }} />
                  LinkedIn
                </p>
              </a>
              <a href="mailto:jazeveedo17@gmail.com" target="_blank" rel="noopener noreferrer" style={{ textDecoration: "none" }}>
                <p
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "4px",
                    border: "1px solid #98c0ef",
                    borderRadius: "90px",
                    padding: "6px 14px",
                    background: "#98c0ef26",
                    fontFamily: "DM Mono, monospace",
                    fontSize: "12px",
                    fontWeight: "500",
                    color: "#d8ecf8",
                  }}>
                  <img src={email} alt="Jason Azevedo LinkedIn" style={{ height: "14px" }} />
                  Email
                </p>
              </a>
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "4px",
                border: "1px solid #22c55e7a",
                borderRadius: "90px",
                padding: "6px 14px",
                background: "#22c55e24",
              }}>
              <div class="pulsating-circle" style={{ marginTop: "10px" }}></div>
              <p style={{ margin: "0", color: "rgb(61 246 129)", fontFamily: "DM Mono, monospace", fontSize: "11px", fontWeight: "400" }}>
                Available for projects
              </p>
            </div>
          </div>
        </div>
        <div>
          <b style={{ color: "rgb(152, 192, 239)", fontFamily: "DM Mono, monospace", fontSize: "12px", fontWeight: "400" }}>ABOUT ME</b>
          <p style={{ marginBottom: "30px", fontWeight: "500", marginTop: "20px" }} className="tl-org">
            Grew up in the islands of Azores, Portugal. Started my journey as a developer but UX/UI Design immediately pulled me in because I believe
            every blank canvas has the potential to become something the world hasn't seen yet.
          </p>
          <p style={{ marginBottom: "30px", fontWeight: "500" }} className="tl-org">
            I'm driven by the belief that no idea is too big and no problem is unsolvable. I'm happiest when I'm turning user needs into outcomes that
            actually move a business forward.
          </p>
          <p style={{ marginBottom: "30px", fontWeight: "500" }} className="tl-org">
            My background in psychology gives me a deeper lens into how people think, make decisions, and respond to what they see. It allows me to
            design with the user's mind in mind, not just their eyes.
          </p>
          <p style={{ fontWeight: "500" }} className="tl-org">
            On my free time I'm a huge Star Wars fan. I enjoy collecting and building LEGO's or just diving deep in the nostalgia of retro games.
          </p>
        </div>
      </div>
      <div className="seperator"></div>
      <div style={{ margin: "80px auto" }} className="middle" id="section-journey">
        <h2 className="cert-sub" style={{ marginBottom: "30px" }}>
          Journey & Experience
        </h2>
        <div class="tl-section">
          <div class="tl-entry dot-purple">
            <div class="tl-card">
              <p class="tl-date color-purple">Feb 2026 – Present</p>
              <p class="tl-role">Lead UX/UI Designer</p>
              <p class="tl-org">youbloom · Remote</p>
              <ul class="tl-bullets">
                <li>Introduced Miro and Trello to streamline Agile workflows, contributing to a 34% increase in user engagement.</li>
                <li>Reduced design revision cycles by 35% by bridging communication between technical and non-technical stakeholders.</li>
                <li>Shortened release cycles by 29% through cross-functional alignment across UX, engineering, and executive teams.</li>
              </ul>
            </div>
            <div class="tl-image">
              <img
                alt=""
                aria-hidden="true"
                loading="lazy"
                width="160"
                height="160"
                decoding="async"
                data-nimg="1"
                class="drop-shadow-2xl"
                src={satellite}></img>
            </div>
          </div>

          <div class="tl-entry right dot-orange">
            <div class="tl-image">
              <img
                alt=""
                aria-hidden="true"
                loading="lazy"
                width="160"
                height="160"
                decoding="async"
                data-nimg="1"
                class="drop-shadow-2xl"
                src={barchart}></img>
            </div>
            <div class="tl-card">
              <p class="tl-date color-orange">Jun 2025 – Present</p>
              <p class="tl-role">Full-Stack Developer & Product Research Designer</p>
              <p class="tl-org">OffMeta Fantasy · CEO</p>
              <ul class="tl-bullets">
                <li>Achieved a 92% user retention rate by translating research findings into user-centered Figma prototypes and high-fidelity UI.</li>
                <li>Increased beta-user engagement by 29% through A/B testing and iterative UX research during product cycles.</li>
                <li>Built a full-stack platform from the ground up using React, Node.js, Express, and PostgreSQL.</li>
              </ul>
            </div>
          </div>

          <div class="tl-entry dot-green">
            <div class="tl-card">
              <p class="tl-date color-green">Jan 2024 – Dec 2024</p>
              <p class="tl-role">Product Research & Designer</p>
              <p class="tl-org">LeadrPro · Remote</p>
              <ul class="tl-bullets">
                <li>Led a product redesign driving ~600 new users, a 35% conversion rate, and an 80–100% revenue increase.</li>
                <li>Increased user engagement by 50% through A/B testing, heatmaps, and continuous user feedback analysis.</li>
                <li>Decreased time-to-market by 25% by developing a responsive design system with a global cross-functional team.</li>
              </ul>
            </div>
            <div class="tl-image">
              <img
                alt=""
                aria-hidden="true"
                loading="lazy"
                width="160"
                height="160"
                decoding="async"
                data-nimg="1"
                class="drop-shadow-2xl"
                src={clipboard}></img>
            </div>
          </div>

          <div class="tl-entry right dot-blue">
            <div class="tl-image">
              <img
                alt=""
                aria-hidden="true"
                loading="lazy"
                width="160"
                height="160"
                decoding="async"
                data-nimg="1"
                class="drop-shadow-2xl"
                src={server}></img>
            </div>
            <div class="tl-card">
              <p class="tl-date color-blue">Sep 2017 – Sep 2019</p>
              <p class="tl-role">IT Administrator</p>
              <p class="tl-org">Pelham School District · Pelham, NH</p>
              <ul class="tl-bullets">
                <li>Owned end-to-end delivery of a high-visibility product initiative from scoping to launch.</li>
                <li>Partnered with design and engineering to ship 3 major feature releases on schedule.</li>
              </ul>
            </div>
          </div>
        </div>

        <p class="tl-section-label">Education</p>
        <div class="tl-section">
          <div class="tl-entry dot-pink">
            <div class="tl-card">
              <p class="tl-date color-pink">2021 – 2023</p>
              <p class="tl-role">Bachelor of Science, Website Design & Development</p>
              <p class="tl-org">FullSail University · Orlando, FL</p>
              <ul class="tl-bullets">
                <li>Graduated with honors, GPA 3.93/4.0.</li>
                <li>Class Salutatorian</li>
              </ul>
            </div>
            <div class="tl-image">
              <img
                alt=""
                aria-hidden="true"
                loading="lazy"
                width="160"
                height="160"
                decoding="async"
                data-nimg="1"
                class="drop-shadow-2xl"
                src={bulb}></img>
            </div>
          </div>
          <div class="tl-entry right dot-yellow">
            <div class="tl-card">
              <p class="tl-date color-yellow">2017 – 2019</p>
              <p class="tl-role">Associate Degree, Social Psychology</p>
              <p class="tl-org">SNHU · Manchester, NH</p>
              <ul class="tl-bullets">
                <li>Owned end-to-end delivery of a high-visibility product initiative from scoping to launch.</li>
                <li>Partnered with design and engineering to ship 3 major feature releases on schedule.</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className="seperator"></div>
      <div className="middle" id="section-work">
        <h2 className="cert-sub" style={{ marginBottom: "30px" }}>
          Selected Work
        </h2>
        <div
          style={{ display: "flex", flexDirection: "column", marginTop: "2rem", maxWidth: "900px", margin: "auto", gap: "80px" }}
          className="case-studies">
          <div
            onMouseEnter={(e) => {
              setTooltipText("View Case Study");
              setTooltip((prev) => ({ ...prev, visible: true }));
            }}
            onMouseLeave={() => {
              setTooltip((prev) => ({ ...prev, visible: false }));
            }}
            onMouseMove={(e) => {
              setTooltip({
                visible: true,
                x: e.clientX,
                y: e.clientY,
              });
            }}>
            <Link to="/research/InglesMarkets" style={{ textDecoration: "none" }}>
              <img src={piece1000} alt="de" />
              <div className="piece" style={{ border: "none", padding: "40px 20px", width: "100%", maxWidth: "none", marginBottom: "0" }}>
                <p class="tl-role" style={{ fontSize: "28px" }}>
                  Ingles Markets Concept UX Research
                </p>
                <p class="tl-org" style={{ fontFamily: "DM Mono, monospace", fontSize: "11px", fontWeight: "400" }}>
                  UX / Product Designer · User Friction · UX Flow Charting
                </p>
                <div style={{ display: "flex", gap: "6px", alignItems: "center", border: "none" }}>
                  <p
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                      border: "1px solid #98c0ef",
                      borderRadius: "90px",
                      padding: "6px 14px",
                      background: "#98c0ef26",
                      fontFamily: "DM Mono, monospace",
                      fontSize: "11px",
                      fontWeight: "400",
                      color: "#d8ecf8",
                    }}>
                    Prototyping
                  </p>
                  <p
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                      border: "1px solid #98c0ef",
                      borderRadius: "90px",
                      padding: "6px 14px",
                      background: "#98c0ef26",
                      fontFamily: "DM Mono, monospace",
                      fontSize: "11px",
                      fontWeight: "400",
                      color: "#d8ecf8",
                    }}>
                    UX Research
                  </p>
                  <p
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                      border: "1px solid #98c0ef",
                      borderRadius: "90px",
                      padding: "6px 14px",
                      background: "#98c0ef26",
                      fontFamily: "DM Mono, monospace",
                      fontSize: "11px",
                      fontWeight: "400",
                      color: "#d8ecf8",
                    }}>
                    Market/Competitor Research
                  </p>
                  <p
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                      border: "1px solid #98c0ef",
                      borderRadius: "90px",
                      padding: "6px 14px",
                      background: "#98c0ef26",
                      fontFamily: "DM Mono, monospace",
                      fontSize: "11px",
                      fontWeight: "400",
                      color: "#d8ecf8",
                    }}>
                    Dashboard Design
                  </p>
                  <p
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                      border: "1px solid #98c0ef",
                      borderRadius: "90px",
                      padding: "6px 14px",
                      background: "#98c0ef26",
                      fontFamily: "DM Mono, monospace",
                      fontSize: "11px",
                      fontWeight: "400",
                      color: "#d8ecf8",
                    }}>
                    Team Leading
                  </p>
                  <p
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                      border: "1px solid #98c0ef",
                      borderRadius: "90px",
                      padding: "6px 14px",
                      background: "#98c0ef26",
                      fontFamily: "DM Mono, monospace",
                      fontSize: "11px",
                      fontWeight: "400",
                      color: "#d8ecf8",
                    }}>
                    Usability Testing
                  </p>
                </div>
                <p class="tl-org" style={{ fontSize: "12px", fontWeight: "500", textTransform: "none", fontFamily: "unset", lineHeight: "21px" }}>
                  A UX-focused concept redesign built to reduce friction, improve mobile usability, and modernize the digital grocery experience.
                </p>
              </div>
            </Link>
          </div>
          <div
            onMouseEnter={(e) => {
              setTooltipText("Current Project (N/A)");
              setTooltip((prev) => ({ ...prev, visible: true }));
            }}
            onMouseLeave={() => {
              setTooltip((prev) => ({ ...prev, visible: false }));
            }}
            onMouseMove={(e) => {
              setTooltip({
                visible: true,
                x: e.clientX,
                y: e.clientY,
              });
            }}>
            <Link to="" style={{ textDecoration: "none" }}>
              <img src={piece8} alt="de" />
              <div className="piece" style={{ border: "none", padding: "40px 20px", width: "100%", maxWidth: "none", marginBottom: "0" }}>
                <p class="tl-role" style={{ fontSize: "28px" }}>
                  youbloom
                </p>
                <p class="tl-org" style={{ fontFamily: "DM Mono, monospace", fontSize: "11px", fontWeight: "400" }}>
                  Lead UX/UI Designer · Pilot Dashboard Design · User Friction · UX Flow Charting
                </p>
                <div style={{ display: "flex", gap: "6px", alignItems: "center", border: "none" }}>
                  <p
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                      border: "1px solid #98c0ef",
                      borderRadius: "90px",
                      padding: "6px 14px",
                      background: "#98c0ef26",
                      fontFamily: "DM Mono, monospace",
                      fontSize: "11px",
                      fontWeight: "400",
                      color: "#d8ecf8",
                    }}>
                    Prototyping
                  </p>
                  <p
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                      border: "1px solid #98c0ef",
                      borderRadius: "90px",
                      padding: "6px 14px",
                      background: "#98c0ef26",
                      fontFamily: "DM Mono, monospace",
                      fontSize: "11px",
                      fontWeight: "400",
                      color: "#d8ecf8",
                    }}>
                    UX Research
                  </p>
                  <p
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                      border: "1px solid #98c0ef",
                      borderRadius: "90px",
                      padding: "6px 14px",
                      background: "#98c0ef26",
                      fontFamily: "DM Mono, monospace",
                      fontSize: "11px",
                      fontWeight: "400",
                      color: "#d8ecf8",
                    }}>
                    Market/Competitor Research
                  </p>
                  <p
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                      border: "1px solid #98c0ef",
                      borderRadius: "90px",
                      padding: "6px 14px",
                      background: "#98c0ef26",
                      fontFamily: "DM Mono, monospace",
                      fontSize: "11px",
                      fontWeight: "400",
                      color: "#d8ecf8",
                    }}>
                    Dashboard Design
                  </p>
                  <p
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                      border: "1px solid #98c0ef",
                      borderRadius: "90px",
                      padding: "6px 14px",
                      background: "#98c0ef26",
                      fontFamily: "DM Mono, monospace",
                      fontSize: "11px",
                      fontWeight: "400",
                      color: "#d8ecf8",
                    }}>
                    Team Leading
                  </p>
                  <p
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                      border: "1px solid #98c0ef",
                      borderRadius: "90px",
                      padding: "6px 14px",
                      background: "#98c0ef26",
                      fontFamily: "DM Mono, monospace",
                      fontSize: "11px",
                      fontWeight: "400",
                      color: "#d8ecf8",
                    }}>
                    Usability Testing
                  </p>
                </div>
                <p class="tl-org" style={{ fontSize: "12px", fontWeight: "500", textTransform: "none", fontFamily: "unset", lineHeight: "21px" }}>
                  Conducted mixed-methods UX Research using surveys, competitor analysis, and usability testing to evaluate express lane user
                  experience. Applied thematic analysis and affinity mapping to map a low friction user journey from landing page to dashboard
                  checkout. Led a team of 4+ designer to a coordinated and efficiend workflow while keeping clear communication and goals through
                  stand up meetings and weekly sprints.
                </p>
              </div>
            </Link>
          </div>
          <div
            onMouseEnter={(e) => {
              setTooltipText("View Case Study");
              setTooltip((prev) => ({ ...prev, visible: true }));
            }}
            onMouseLeave={() => {
              setTooltip((prev) => ({ ...prev, visible: false }));
            }}
            onMouseMove={(e) => {
              setTooltip({
                visible: true,
                x: e.clientX,
                y: e.clientY,
              });
            }}>
            <Link to="/research/LeadrPro" style={{ textDecoration: "none" }}>
              <img src={piece4} alt="de" />
              <div className="piece" style={{ border: "none", padding: "40px 20px", width: "100%", maxWidth: "none", marginBottom: "0" }}>
                <p class="tl-role" style={{ fontSize: "28px" }}>
                  LeadrPro
                </p>
                <p class="tl-org" style={{ fontFamily: "DM Mono, monospace", fontSize: "11px", fontWeight: "400" }}>
                  Product Research & Designer · Product Design · B2B Pipeline · Dashboard Design
                </p>
                <div style={{ display: "flex", gap: "6px", alignItems: "center", border: "none" }}>
                  <p
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                      border: "1px solid #98c0ef",
                      borderRadius: "90px",
                      padding: "6px 14px",
                      background: "#98c0ef26",
                      fontFamily: "DM Mono, monospace",
                      fontSize: "11px",
                      fontWeight: "400",
                      color: "#d8ecf8",
                    }}>
                    Affinity Mapping
                  </p>
                  <p
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                      border: "1px solid #98c0ef",
                      borderRadius: "90px",
                      padding: "6px 14px",
                      background: "#98c0ef26",
                      fontFamily: "DM Mono, monospace",
                      fontSize: "11px",
                      fontWeight: "400",
                      color: "#d8ecf8",
                    }}>
                    UX Research
                  </p>
                  <p
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                      border: "1px solid #98c0ef",
                      borderRadius: "90px",
                      padding: "6px 14px",
                      background: "#98c0ef26",
                      fontFamily: "DM Mono, monospace",
                      fontSize: "11px",
                      fontWeight: "400",
                      color: "#d8ecf8",
                    }}>
                    Market/Competitor Research
                  </p>
                  <p
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                      border: "1px solid #98c0ef",
                      borderRadius: "90px",
                      padding: "6px 14px",
                      background: "#98c0ef26",
                      fontFamily: "DM Mono, monospace",
                      fontSize: "11px",
                      fontWeight: "400",
                      color: "#d8ecf8",
                    }}>
                    Journey Mapping
                  </p>
                  <p
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                      border: "1px solid #98c0ef",
                      borderRadius: "90px",
                      padding: "6px 14px",
                      background: "#98c0ef26",
                      fontFamily: "DM Mono, monospace",
                      fontSize: "11px",
                      fontWeight: "400",
                      color: "#d8ecf8",
                    }}>
                    Task Flows
                  </p>
                  <p
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                      border: "1px solid #98c0ef",
                      borderRadius: "90px",
                      padding: "6px 14px",
                      background: "#98c0ef26",
                      fontFamily: "DM Mono, monospace",
                      fontSize: "11px",
                      fontWeight: "400",
                      color: "#d8ecf8",
                    }}>
                    Brand Design
                  </p>
                </div>
                <p class="tl-org" style={{ fontSize: "12px", fontWeight: "500", textTransform: "none", fontFamily: "unset", lineHeight: "21px" }}>
                  Conducted contextual interviews with past and present C-Suite level users to understand workload tracking pain points. Performed
                  affinity mapping to identify recurring themes and synthesized insights into journey maps and taks flows, proposing a streamlined
                  dashboard design that improved task ownership clarity.
                </p>
              </div>
            </Link>
          </div>
          <div
            onMouseEnter={(e) => {
              setTooltipText("View Case Study");
              setTooltip((prev) => ({ ...prev, visible: true }));
            }}
            onMouseLeave={() => {
              setTooltip((prev) => ({ ...prev, visible: false }));
            }}
            onMouseMove={(e) => {
              setTooltip({
                visible: true,
                x: e.clientX,
                y: e.clientY,
              });
            }}>
            <Link to="/research/OffMetaFantasy" style={{ textDecoration: "none" }}>
              <img src={piece10} alt="de" />
              <div className="piece" style={{ border: "none", padding: "40px 20px", width: "100%", maxWidth: "none", marginBottom: "0" }}>
                <p class="tl-role" style={{ fontSize: "28px" }}>
                  OffMeta Fantasy
                </p>
                <p class="tl-org" style={{ fontFamily: "DM Mono, monospace", fontSize: "11px", fontWeight: "400" }}>
                  Full-Stack Developer & Product Research Designer · CEO Founder
                </p>
                <div style={{ display: "flex", gap: "6px", alignItems: "center", border: "none" }}>
                  <p
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                      border: "1px solid #98c0ef",
                      borderRadius: "90px",
                      padding: "6px 14px",
                      background: "#98c0ef26",
                      fontFamily: "DM Mono, monospace",
                      fontSize: "11px",
                      fontWeight: "400",
                      color: "#d8ecf8",
                    }}>
                    Backend Coding
                  </p>
                  <p
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                      border: "1px solid #98c0ef",
                      borderRadius: "90px",
                      padding: "6px 14px",
                      background: "#98c0ef26",
                      fontFamily: "DM Mono, monospace",
                      fontSize: "11px",
                      fontWeight: "400",
                      color: "#d8ecf8",
                    }}>
                    Frontend Coding
                  </p>
                  <p
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                      border: "1px solid #98c0ef",
                      borderRadius: "90px",
                      padding: "6px 14px",
                      background: "#98c0ef26",
                      fontFamily: "DM Mono, monospace",
                      fontSize: "11px",
                      fontWeight: "400",
                      color: "#d8ecf8",
                    }}>
                    Market Research
                  </p>
                  <p
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                      border: "1px solid #98c0ef",
                      borderRadius: "90px",
                      padding: "6px 14px",
                      background: "#98c0ef26",
                      fontFamily: "DM Mono, monospace",
                      fontSize: "11px",
                      fontWeight: "400",
                      color: "#d8ecf8",
                    }}>
                    Product Design
                  </p>
                  <p
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                      border: "1px solid #98c0ef",
                      borderRadius: "90px",
                      padding: "6px 14px",
                      background: "#98c0ef26",
                      fontFamily: "DM Mono, monospace",
                      fontSize: "11px",
                      fontWeight: "400",
                      color: "#d8ecf8",
                    }}>
                    Postgres & React
                  </p>
                  <p
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                      border: "1px solid #98c0ef",
                      borderRadius: "90px",
                      padding: "6px 14px",
                      background: "#98c0ef26",
                      fontFamily: "DM Mono, monospace",
                      fontSize: "11px",
                      fontWeight: "400",
                      color: "#d8ecf8",
                    }}>
                    User Surveys
                  </p>
                </div>
                <p class="tl-org" style={{ fontSize: "12px", fontWeight: "500", textTransform: "none", fontFamily: "unset", lineHeight: "21px" }}>
                  I architected and shipped the full product. Designing the PostgreSQL database schema, building a REST API backend, and developing
                  the React frontend. Additionally, I led UX research efforts including small scale user surveys, competitor analysis, and usability
                  testing to inform product decisions.
                </p>
              </div>
            </Link>
          </div>
          {/* <div>
            <img src={piece1} alt="de" />
            <a href="https://www.behance.net/gallery/177335085/League-of-Legends-Worlds-2023" target="_blank" rel="noopener noreferrer">
              <div className="piece" style={{ border: "none" }}>
                <p>League of Legends Worlds 2023</p>
              </div>
            </a>
          </div> */}
          {/* <div
            onMouseEnter={(e) => {
              setTooltipText("View on Behance");
              setTooltip((prev) => ({ ...prev, visible: true }));
            }}
            onMouseLeave={() => {
              setTooltip((prev) => ({ ...prev, visible: false }));
            }}
            onMouseMove={(e) => {
              setTooltip({
                visible: true,
                x: e.clientX,
                y: e.clientY,
              });
            }}>
            <Link to="https://www.behance.net/gallery/221874613/Supervive-Esports-Concept-Design" style={{ textDecoration: "none" }}>
              <img src={piece9} alt="de" />
              <div className="piece" style={{ border: "none" }}>
                <p>Supervive Esports</p>
              </div>
            </Link>
          </div> */}
          {/* <div
            onMouseEnter={(e) => {
              setTooltipText("View on Behance while I write case study");
              setTooltip((prev) => ({ ...prev, visible: true }));
            }}
            onMouseLeave={() => {
              setTooltip((prev) => ({ ...prev, visible: false }));
            }}
            onMouseMove={(e) => {
              setTooltip({
                visible: true,
                x: e.clientX,
                y: e.clientY,
              });
            }}>
            <Link to="https://www.behance.net/gallery/206086833/Listo-Design-Concept" style={{ textDecoration: "none" }}>
              <img src={piece5} alt="de" />
              <div className="piece" style={{ border: "none", padding: "40px 20px", width: "100%", maxWidth: "none", marginBottom: "0" }}>
                <p class="tl-role" style={{ fontSize: "28px" }}>
                  Listo Landing Page
                </p>
                <p class="tl-org" style={{ fontFamily: "DM Mono, monospace", fontSize: "11px", fontWeight: "400" }}>
                  UX/UI Designer · Contract
                </p>
                <div style={{ display: "flex", gap: "6px", alignItems: "center", border: "none" }}>
                  <p
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                      border: "1px solid #98c0ef",
                      borderRadius: "90px",
                      padding: "6px 14px",
                      background: "#98c0ef26",
                      fontFamily: "DM Mono, monospace",
                      fontSize: "11px",
                      fontWeight: "400",
                      color: "#d8ecf8",
                    }}>
                    UI Design
                  </p>
                  <p
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                      border: "1px solid #98c0ef",
                      borderRadius: "90px",
                      padding: "6px 14px",
                      background: "#98c0ef26",
                      fontFamily: "DM Mono, monospace",
                      fontSize: "11px",
                      fontWeight: "400",
                      color: "#d8ecf8",
                    }}>
                    Market Research
                  </p>
                  <p
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                      border: "1px solid #98c0ef",
                      borderRadius: "90px",
                      padding: "6px 14px",
                      background: "#98c0ef26",
                      fontFamily: "DM Mono, monospace",
                      fontSize: "11px",
                      fontWeight: "400",
                      color: "#d8ecf8",
                    }}>
                    Product Design
                  </p>
                </div>
                <p class="tl-org" style={{ fontSize: "12px", fontWeight: "500", textTransform: "none", fontFamily: "unset", lineHeight: "21px" }}>
                  Conducted mixed-methods UX Research using surveys, competitor analysis, and usability testing to evaluate express lane user
                  experience. Applied thematic analysis and affinity mapping to map a low friction user journey from landing page to dashboard
                  checkout.
                </p>
              </div>
            </Link>
          </div> */}
          {/* <div
            onMouseEnter={(e) => {
              setTooltipText("View on Behance while I write case study");
              setTooltip((prev) => ({ ...prev, visible: true }));
            }}
            onMouseLeave={() => {
              setTooltip((prev) => ({ ...prev, visible: false }));
            }}
            onMouseMove={(e) => {
              setTooltip({
                visible: true,
                x: e.clientX,
                y: e.clientY,
              });
            }}>
            <Link to="https://www.behance.net/gallery/170967997/Thistle-Communications-Brand-DesignWebsite" style={{ textDecoration: "none" }}>
              <img src={piece2} alt="de" />
              <div className="piece" style={{ border: "none" }}>
                <p>Thistle Communications</p>
              </div>
            </Link>
          </div> */}
        </div>
      </div>
      <div className="seperator"></div>
      <div className="middle" id="section-work">
        <h2 className="cert-sub" style={{ marginBottom: "30px" }}>
          Designs without case-studies
        </h2>
        <div
          className="case-studies-empty"
          style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: "30px", margin: "0 auto", position: "relative", zIndex: "100" }}>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))", gap: "20px" }}>
            <Link
              to="/screens/orbitly"
              style={{ textDecoration: "none" }}
              onMouseEnter={(e) => {
                setTooltipText("View");
                setTooltip((prev) => ({ ...prev, visible: true }));
              }}
              onMouseLeave={() => setTooltip((prev) => ({ ...prev, visible: false }))}
              onMouseMove={(e) => setTooltip({ visible: true, x: e.clientX, y: e.clientY })}>
              <div className="dribbble-card">
                <div className="dribbble-card__img">
                  <img src={piece1} alt="Listo Landing Page" />
                </div>
              </div>
            </Link>
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))", gap: "20px" }}>
            <Link
              to="/screens/listo"
              style={{ textDecoration: "none" }}
              onMouseEnter={(e) => {
                setTooltipText("View");
                setTooltip((prev) => ({ ...prev, visible: true }));
              }}
              onMouseLeave={() => setTooltip((prev) => ({ ...prev, visible: false }))}
              onMouseMove={(e) => setTooltip({ visible: true, x: e.clientX, y: e.clientY })}>
              <div className="dribbble-card">
                <div className="dribbble-card__img">
                  <img src={piece5} alt="Listo Landing Page" />
                </div>
              </div>
            </Link>
          </div>
        </div>
      </div>
      {tooltip.visible && (
        <div
          style={{
            position: "fixed",
            left: tooltip.x + 16,
            top: tooltip.y + 16,
            pointerEvents: "none",
            zIndex: 9999,
            padding: "8px 14px",
            borderRadius: "999px",
            background: "#98c0ef",
            color: "#0b1117",
            fontFamily: "DM Mono, monospace",
            fontSize: "11px",
            fontWeight: "500",
            whiteSpace: "nowrap",
            boxShadow: "0 4px 20px rgba(0,0,0,0.2)",
          }}>
          {tooltipText} <span style={{ fontSize: "14px" }}>↗</span>
        </div>
      )}
    </div>
  );
};

export default Home;
